import Outstock from '@/service/outstock'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getoutstockorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getoutstockorders(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getoutstockorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getoutstockorder(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getoutstocks(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getoutstocks(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getoutstock(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getoutstock(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addoutstockorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.addoutstockorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteoutstockorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.deleteoutstockorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    closeoutstockorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.closeoutstockorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getwarehouses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getwarehouses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    updatewarehouse(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.updatewarehouse(payload), {
        type: 'action',
        success,
        fail
      })
    },
    setweightandvolume(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.setweightandvolume(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getoutlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getoutlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    stocklist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.stocklist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getsaleslist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getsaleslist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getsendlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getsendlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    uploadsales(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.uploadsales(payload), {
        type: 'action',
        success,
        fail
      })
    },
    salesremark(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salesremark(payload), {
        type: 'action',
        success,
        fail
      })
    },
    salesadd(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salesadd(payload), {
        type: 'action',
        success,
        fail
      })
    },
    salesfinish(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salesfinish(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deaudit(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.deaudit(payload), {
        type: 'action',
        success,
        fail
      })
    },
    salescancel(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salescancel(payload), {
        type: 'action',
        success,
        fail
      })
    },
    salesdelete(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salesdelete(payload), {
        type: 'action',
        success,
        fail
      })
    },
    salesdetail(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salesdetail(payload), {
        type: 'info',
        success,
        fail
      })
    },
    salesouttypeaudit(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salesouttypeaudit(payload), {
        type: 'action',
        success,
        fail
      })
    },
    salesbatchaudit(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.salesbatchaudit(payload), {
        type: 'action',
        success,
        fail
      })
    },
    outadd(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.outadd(payload), {
        type: 'action',
        success,
        fail
      })
    },
    outsendadd(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.outsendadd(payload), {
        type: 'action',
        success,
        fail
      })
    },
    outsendadd1(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.outsendadd(payload), {
        type: 'info',
        success,
        fail
      })
    },
    sendadd(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.sendadd(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addbysalesorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.addbysalesorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    hascombineddelivery(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.hascombineddelivery(payload), {
        type: 'info',
        success,
        fail
      })
    },
    outcancel(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.outcancel(payload), {
        type: 'action',
        success,
        fail
      })
    },
    outdetail(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.outdetail(payload), {
        type: 'info',
        success,
        fail
      })
    },
    tallyorderlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.tallyorderlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    tallyorderdetail(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.tallyorderdetail(payload), {
        type: 'info',
        success,
        fail
      })
    },
    tallyorderitemlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.tallyorderitemlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    tallyorderadd(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.tallyorderadd(payload), {
        type: 'action',
        success,
        fail
      })
    },
    tallyorderprint(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.tallyorderprint(payload), {
        type: 'action',
        success,
        fail
      })
    },
    checkorderlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.checkorderlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    checkorderdetail(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.checkorderdetail(payload), {
        type: 'info',
        success,
        fail
      })
    },
    expressprint(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.expressprint(payload), {
        type: 'info',
        success,
        fail
      })
    },
    sendlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.sendlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    refundlist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.refundlist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    refunddetail(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.refunddetail(payload), {
        type: 'info',
        success,
        fail
      })
    },
    allocatelist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.allocatelist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    allocatedetail(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.allocatedetail(payload), {
        type: 'info',
        success,
        fail
      })
    },
    allocateaudit(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.allocateaudit(payload), {
        type: 'action',
        success,
        fail
      })
    },
    allocateadd(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.allocateadd(payload), {
        type: 'action',
        success,
        fail
      })
    },
    allocatefinish(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.allocatefinish(payload), {
        type: 'action',
        success,
        fail
      })
    },
    allocatedeaudit(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.allocatedeaudit(payload), {
        type: 'action',
        success,
        fail
      })
    },
    downloadorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.downloadorders(payload), {
        type: 'file',
        success,
        fail
      })
    },
    downloadcouriers(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.downloadcouriers(payload), {
        type: 'file',
        success,
        fail
      })
    },
    downloadoutorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.downloadoutorders(payload), {
        type: 'file',
        success,
        fail
      })
    },
    getoutstocktags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.getoutstocktags(payload), {
        type: 'info',
        success,
        fail
      })
    },
    confirmallreturn(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Outstock.confirmallreturn(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
